import {ACTION_TYPES, userSet} from '../app.types';
import {AuthorizationUtils} from '../utils/authorization.utils';
import {UserAction} from './user.actions';
import {UserModel} from './user.model';
import {createFeatureSelector, createSelector} from '@ngrx/store';
import {segmentsFeatureSelector} from '../segment/segments.state';

export interface UserState {
  user: UserModel,
  isAdmin: boolean,
}

export const INITIAL_USER_STATE: UserState = {
  user: {} as UserModel,
  isAdmin: false,
};

export const usersFeatureSelector = createFeatureSelector<UserState>('userContainer');
export const selectPartnerId = createSelector(
  usersFeatureSelector,
  (state) => state.user.partnerId
);
export const selectUserIsAdmin = createSelector(
  usersFeatureSelector,
  (state) => state.isAdmin
);
export const selectUserName = createSelector(
  usersFeatureSelector,
  (state) => state.user.username
);
export const selectCanViewValidations = createSelector(
  usersFeatureSelector,
  (state) => AuthorizationUtils.canViewSegmentValidations(state.user)
);
export const selectCanViewSegmentAuditLogs = createSelector(
  usersFeatureSelector,
  (state) => AuthorizationUtils.canViewSegmentAuditLogs(state.user)
);
export const selectCanDeleteSegment = createSelector(
  usersFeatureSelector,
  segmentsFeatureSelector,
  (user, segments) => AuthorizationUtils.canDeleteSegment(user.user, segments.segmentDetails?.segment)
);
export const selectCanEditSegment = createSelector(
  usersFeatureSelector,
  segmentsFeatureSelector,
  (user, segments) => AuthorizationUtils.canEditSegment(user.user, segments.segmentDetails?.segment)
);

export function userContainer(state = INITIAL_USER_STATE,
                              action: UserAction = {type: '?'}) {

  switch (action.type) {
    case userSet.type:
      return {
        ...state,
        user: action.user,
        isAdmin: AuthorizationUtils.isAdmin(action.user),
      };
    case ACTION_TYPES.USER_CLEAR:
      return {...state, user: null, isAdmin: false};
    case ACTION_TYPES.USER_CHANGED_UNAUTHORIZED:
      return {...state};
    default:
      return {...state};
  }
}

export const userSelector = (state: any): UserModel => state.userContainer.user;
export const userIsAdminSelector = (state: any): boolean => state.userContainer.isAdmin;
export const userIsSuperAdminSelector = (state: any): boolean => state.userContainer.user.roles.includes('superadmin');
